const CanadaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111080)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M40.0002 20.0008C40.0002 12.0716 35.3857 5.22035 28.6958 1.98535V38.0162C35.3857 34.7813 40.0002 27.93 40.0002 20.0008Z"
        fill="#D80027"
      />
      <path
        d="M0 20.0008C0 27.93 4.61445 34.7813 11.3044 38.0163V1.98535C4.61445 5.22035 0 12.0716 0 20.0008Z"
        fill="#D80027"
      />
      <path
        d="M23.4782 22.6087L26.9564 20.8696L25.2174 20V18.2609L21.7391 20L23.4782 16.5218H21.7391L19.9999 13.9131L18.2608 16.5218H16.5217L18.2608 20L14.7825 18.2609V20L13.0435 20.8696L16.5217 22.6087L15.6521 24.3479H19.1304V26.9565H20.8695V24.3479H24.3478L23.4782 22.6087Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111080">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CanadaSvg;
